"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlgoliaPageFilters = void 0;
const getAlgoliaPageFilters = (filter) => filter?.includePreviewPages ? undefined : 'inPreview:false';
exports.getAlgoliaPageFilters = getAlgoliaPageFilters;
//# sourceMappingURL=getAlgoliaPageFilters.js.map